import { useNavigate, type NavigateFunction } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import { useEffect } from "react";
import routes from "./config";

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
    __READDY_ROUTES__?: { path?: string }[];
  }
}

/** Readdy preview may await routes before React mounts — expose synchronously. */
if (typeof window !== "undefined") {
  try {
    window.__READDY_ROUTES__ = routes.map((r) => ({ path: r.path }));
  } catch {
    // ignore preview environments that block window mutation
  }
}

const previewNavigateFallback = ((() => {
  // noop — replaced once React Router mounts
}) as unknown) as NavigateFunction;

let navigateResolver: (navigate: NavigateFunction) => void;

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
  // Readdy import/preview can await this before React mounts.
  if (typeof __IS_PREVIEW__ !== "undefined" && __IS_PREVIEW__) {
    resolve(previewNavigateFallback);
  }
});

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();
  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(navigate);
    try {
      window.__READDY_ROUTES__ = routes.map((r) => ({ path: r.path }));
    } catch {
      // Silently ignore if Readdy preview can't read routes
    }
  }, [navigate]);
  return element;
}